var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tenantId && _vm.isReady)?_c('Layout',{attrs:{"page":_vm.page}},[_c('RouterView',{on:{"page":function($event){_vm.page = $event}}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }